import React from "react";
import ThesisSupervision from "./ThesesSupervision";
import FundedResearchProjects from "./FundedResearchProjects";
import Dissertations from "./Dissertations";
import MentorLastRow from "./MentorLastRow";
import CategorySubCategory from "./CategorySubCategory";

const ResearchProjects = ({
  register,
  control,
  errors,
  setValue,
  subjectExpertiseList,
  mentorshipOfferedList,
  userProfile,
  disabled,
}) => {
  return (
    <>
      <ThesisSupervision
        register={register}
        control={control}
        errors={errors}
        disabled={disabled}
      />
      <Dissertations
        register={register}
        control={control}
        errors={errors}
        disabled={disabled}
      />
      <FundedResearchProjects
        register={register}
        control={control}
        errors={errors}
        disabled={disabled}
      />
      <CategorySubCategory
        register={register}
        setValue={setValue}
        subjectExpertiseList={subjectExpertiseList}
        mentorshipOfferedList={mentorshipOfferedList}
        apiSubjectExpertise={userProfile.subjectMatterExpertise}
        apiMentorshipOffered={userProfile.mentorshipOffered}
        disabled={disabled}
      />

      <MentorLastRow
        register={register}
        control={control}
        errors={errors}
        setValue={setValue}
        disabled={disabled}
      />
    </>
  );
};

export default ResearchProjects;
